
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[itemID]",
      function () {
        return require("private-next-pages/product/[itemID]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[itemID]"])
      });
    }
  